import { render, staticRenderFns } from "./HeadingSubtitle.vue?vue&type=template&id=0b252623&scoped=true&"
import script from "./HeadingSubtitle.vue?vue&type=script&lang=js&"
export * from "./HeadingSubtitle.vue?vue&type=script&lang=js&"
import style0 from "./HeadingSubtitle.vue?vue&type=style&index=0&id=0b252623&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b252623",
  null
  
)

export default component.exports